import { render, staticRenderFns } from "./PostCreationAttachmentActions.vue?vue&type=template&id=12c9d19d&scoped=true"
import script from "./PostCreationAttachmentActions.vue?vue&type=script&lang=js"
export * from "./PostCreationAttachmentActions.vue?vue&type=script&lang=js"
import style0 from "./PostCreationAttachmentActions.vue?vue&type=style&index=0&id=12c9d19d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c9d19d",
  null
  
)

export default component.exports